"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var PageList_styled_exports = {};
__export(PageList_styled_exports, {
  StyledPageList: () => StyledPageList
});
module.exports = __toCommonJS(PageList_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_mixins = require("../../../themes/mixins");
var StyledPageList = import_styled_components.default.ul.withConfig({
  displayName: "PageListstyled__StyledPageList",
  componentId: "sc-8pax8p-0"
})(function(_ref) {
  var theme = _ref.theme;
  return (0, import_styled_components.css)(["max-height:160px;overflow-y:auto;padding:0;list-style:none;", ";.menu-item{box-sizing:border-box;font-size:", ";font-family:", ";font-weight:", ";display:flex;justify-content:center;align-items:center;", " height:40px;&:hover{background-color:", ";text-decoration:none;}&:focus{border:", " 2px solid;border-radius:0px;outline:none;}}"], (0, import_mixins.withStyledScrollBar)(), theme.typography.sizes.medium, theme.typography.fonts.primary, theme.typography.weights.regular, (0, import_mixins.withPadding)("5px"), theme.colors.beige[100], theme.colors.beige[180]);
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledPageList
});
//# sourceMappingURL=PageList.styled.js.map